<template>
  <div class="im-right-content" :class="isActive ? '' : 'bg'">
    <header class="im-right-content-header" :class="border ? 'border-bottom' : ''">
      <slot name="im-right-content-header"></slot>
    </header>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ImRightContentLayout',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
.im-right-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 0;
}
.im-right-content-header {
  display: flex;
  justify-content: space-between;
  padding: 12px 25px;
  height: 25px;
  line-height: 25px;
}
.border-bottom {
  border-bottom: 1px solid #ded9d9;
}
.bg {
  background: url("/static/qyh.jpg");
  background-repeat: no-repeat;
  background-size: 80px;
  background-position: center calc(50% - 30px);
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ImRightContentLayout.vue